<template>
  <div id="contact">
    <div class="ContentContainer">
      <h1 class="heading-lined">{{ $t("contact_page.contact") }}</h1>
      <h2 class="text-secondary h4 p-0">
        COINTRACKR LTD (reg n°13590431) Incorporated in UK
      </h2>
      <h4 class="mt-5 mb-3">{{ $t("contact_page.help_feedback") }}</h4>
      <p>
        <i class="mr-1 fa fa-fw fa-envelope"></i>
        {{ $t("contact_page.email") }}:
        <a :href="`mailto:${email}`" target="_blank">{{ email }}</a>
      </p>
      <p v-for="social in socials" :key="social.name">
        <i class="mr-1 fa fa-fw" :class="social.iconClass"></i>
        {{ social.name }}:
        <a :href="social.link" target="_blank">{{ social.link }}</a>
      </p>

      <h4 class="mt-5 mb-3">{{ $t("contact_page.busines") }}</h4>
      <p>
        <i class="mr-1 fa fa-fw fa-envelope"></i>
        {{ $t("contact_page.email") }}:
        <a :href="`mailto:${email}`" target="_blank">{{ email }}</a>
      </p>
    </div>
  </div>
</template>

<script>
import options from "@/options";

export default {
  name: "Contact",
  metaInfo: {
    title: "Contact CoinTrackr", 
  },
  created() {
    const socials = options.socials.filter((v) => v.showContact);
    socials.sort((a, b) => a.orderContact - b.orderContact);
    this.socials = socials;
    this.email = options.email;
  },
};
</script>
